export default "__VITE_ASSET__5b35e672__"